import React from 'react'
import { Button, Card } from '@chilecompra/react-kit/components'
import {
  REACT_APP_DATA_COIN_ERROR_URL,
  REACT_APP_DATA_AMOUNT_ERROR_URL,
  REACT_APP_DATA_HISTORIC_COIN_URL,
  REACT_APP_DATA_ITEMS_ONU_URL,
  REACT_APP_DATA_HISTORIC_BUYERS_URL
} from '../../config/settings/environment'
import DownloadsNavButton from '../../components/Navigation/DownloadsNavButton'
import {
  Description,
  CardDescription,
  CardItem,
  CardList,
  CardTitle,
  GridContainer,
  GridItem,
  Link,
  Root,
  Title
} from './DownloadAddonsSection.styles'

/**
 * The DownloadAddonsSection's container.
 */
const DownloadAddonsSection = () => {
  const handleClickLink = url => () => window.open(url, '_top')

  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <DownloadsNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Datos complementarios</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 25px">
        <GridItem xs={12}>
          <Description>
            Los datos complementarios son toda la información extra que sirve como complemento para analizar y conocer
            en detalle el comportamiento de las compras publicas realizadas en la plataforma de Mercado Público.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 48px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer padding="0 0 15px">
              <GridItem xs={12}>
                <CardTitle>Incoherencias de moneda y/o monto</CardTitle>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <CardDescription>
                  Listado de órdenes de compra que presentaron incoherencias con las monedas declaradas y/o con los
                  montos:
                </CardDescription>
                <CardList>
                  <CardItem>
                    <Link href={REACT_APP_DATA_COIN_ERROR_URL}>
                      Descargar listado de órdenes de compra con incoherencia de moneda
                    </Link>
                  </CardItem>
                  <CardItem>
                    <Link href={REACT_APP_DATA_AMOUNT_ERROR_URL}>
                      Descargar listado de órdenes de compra con incoherencia de monto
                    </Link>
                  </CardItem>
                </CardList>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 48px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer padding="0 0 15px">
              <GridItem xs={12}>
                <CardTitle>Registro histórico de equivalencia de moneda</CardTitle>
              </GridItem>
            </GridContainer>
            <GridContainer padding="0 0 25px">
              <GridItem xs={12}>
                <CardDescription>
                  Registros de moneda para el período de registros, con las respectivas equivalencias entre cada moneda.
                </CardDescription>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem align="right" xs={12}>
                <Button color="primary" onClick={handleClickLink(REACT_APP_DATA_HISTORIC_COIN_URL)}>
                  {' '}
                  Descargar archivo
                </Button>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 48px">
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer padding="0 0 15px">
              <GridItem xs={12}>
                <CardTitle>Rubros según Código ONU</CardTitle>
              </GridItem>
            </GridContainer>
            <GridContainer padding="0 0 25px">
              <GridItem xs={12}>
                <CardDescription>
                  Listado de rubros utilizados en Mercado Público con sus respectivos códigos ONU. Estos son utilizados
                  por compradores, los que declaran el rubro del producto comprado o licitado, como también por los
                  proveedores quienes declaran los bienes o servicios que ofrecen.
                </CardDescription>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem align="right" xs={12}>
                <Button color="primary" onClick={handleClickLink(REACT_APP_DATA_ITEMS_ONU_URL)}>
                  Descargar archivo
                </Button>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card color="blank" elevation="1">
            <GridContainer padding="0 0 15px">
              <GridItem xs={12}>
                <CardTitle>Registro histórico de organismos compradores</CardTitle>
              </GridItem>
            </GridContainer>
            <GridContainer padding="0 0 25px">
              <GridItem xs={12}>
                <CardDescription>
                  Listado de todos los organismos compradores que hayan participado de un proceso de compra o
                  licitatorio en Mercado Público, se incluyen todas las unidades de compra de cada organismo así como
                  aquellas instituciones que ya no se encuentren activas.
                </CardDescription>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem align="right" xs={12}>
                <Button color="primary" onClick={handleClickLink(REACT_APP_DATA_HISTORIC_BUYERS_URL)}>
                  Descargar archivo
                </Button>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default DownloadAddonsSection
